<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card>
                <v-card-title>
                    {{ title }}
                </v-card-title>
                <v-card-subtitle>
                    {{ $t("JOBCARD_SPARE_SUBTITLE") }}
                </v-card-subtitle>
                <v-card-text>
                    <div v-if="loading.data" class="text-center">
                        <v-progress-circular
                            indeterminate
                            color="primary">
                        </v-progress-circular>
                    </div>
                    <v-form
                        v-else
                        ref="form"
                        v-model="valid">
                        <v-text-field
                            :readonly="!!form.item_id"
                            @blur="!form.item_id ? form.item = null : null"
                            :clearable="true"
                            :append-icon="form.item_id ? '' : 'mdi-magnify'"
                            @click:clear="form.item_id = null"
                            :label="$t('JOBCARD_SPARE_NAME')"
                            v-model="form.item"
                            :rules="rules.item"
                            @keypress.enter="openSpareSearchDialog">

                        </v-text-field>
                        <v-text-field
                            v-model="form.quantity"
                            :label="$t('JOBCARD_SPARE_QUANTITY')"
                            :rules="rules.quantity">
                        </v-text-field>
                        <v-text-field
                            v-model="form.price"
                            :label="$t('JOBCARD_SPARE_PRICE')"
                            :rules="rules.price">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        @click="submit"
                        :disabled="!valid || loading.data || loading.submit"
                        :loading="loading.submit"
                        >
                        {{ $t("BTN_SAVE") }}
                    </v-btn>
                    <v-btn
                        text
                        @click="close()"
                        >
                        {{ $t("BTN_CANCEL") }}
                        </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog ref="alertDialog"/>
        <SpareSearchDialog
            @submit="fillFeildData"
            ref="spareSearchDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AlertDialog from "../components/AlertDialog";
import SpareSearchDialog from '@/components/SpareSearchDialog';
export default {
    name:"JobcardSpareDialog",
    components: {
        AlertDialog,
        SpareSearchDialog
    },
    data() {
        return {
            display: false,
            editMode: false,
            valid: false,
            id: null,
            form: {
                jobcard_id: null,
                item_id: null,
                item: null,
                description: null,
                quantity: null,
                price: null
            },
            rules: {
                item: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                quantity: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG"), // required
                    v => !isNaN(v) || this.$t("RULES_NUMERIC_MSG")
                ],
                price: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG"),
                    v => !isNaN(v) || this.$t("RULES_NUMERIC_MSG")
                ]
            },
            loading: {
                data: false,
                submit: false
            }
        }
    },
    computed:{
        ...mapState("jobcardSpare", ["jobcardSpare"]),
        ...mapState("authentication", ["authorizations"]),
        title() {
            if(!this.editMode) return this.$t("JOBCARD_SPARE_NEW_TITLE")
            else return this.$t("JOBCARD_SPARE_EDIT_TITLE")
        }
    },
    methods:{
        ...mapActions("jobcardSpare", ["fetchJobcardSpare", "fetchJobcardSpares", "storeJobcardSpare", "updateJobcardSpare"]),
        async open(params) {
            this.editMode = params.editMode;
            this.loading.data = true;
            this.display = true;
            this.form.jobcard_id = params.jobcard_id;
            if(this.editMode) {
                this.id = params.id;
                await this.fetchJobcardSpare(this.id);
                this.form = this.jobcardSpare;
            }
            this.loading.data = false;
        },
        close() {
            this.display = false;
            this.loading.submit = false;
            this.form.item_id = null;
            this.form.item = null;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        fillFeildData(params) {
            this.form.item_id = params.id;
            this.form.item = params.name;
        },
        submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeJobcardSpare(this.form)
                    .then(response => {
                        this.close();
                        this.fetchJobcardSpares(this.form.jobcard_id);
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    });    
            } else {
                this.updateJobcardSpare({form: this.form, id: this.id})
                    .then(response => {
                        this.close();
                        this.fetchJobcardSpares(this.form.jobcard_id);
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    });    
            }
        },
        openSpareSearchDialog() {
            this.$refs.spareSearchDialog.open(this.form.item);
        },
        openItemDialog(params) {
            this.$refs.itemDialog.open(params);
        },
        selectNewItem(record) {
            this.form.item_id = record.id;
        }
    }
}
</script>